import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { connect } from "react-redux";
import Slider from "react-slick";
import { fetchCars } from "../../redux/actions/profileAction";
import Link from "next/link";
import OutsideClickHandler from "react-outside-click-handler";
import moment from "moment";
import { Services } from "../Homepage";
import Skeleton from "react-loading-skeleton";
import Scrollbars from "react-custom-scrollbars";
import WorkshopTime from "../common/WorkshopTime";
import { setLoader } from "../../redux/actions/globalAction";
import { FaTimes } from "react-icons/fa";
import WorkshopStars from "../common/WorkshopStars";

var settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  initialSlide: 0,
};

function WorkshopModal({
  workShop,
  amenitiesData,
  days,
  workshopJourneyCategoryData,
  globalData,
  setHide,
  setLoader,
}) {
  const [fullDate, setFullDate] = useState(false);
  const [data, setData] = useState([]);

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: data?.length > 4 ? 4 : data?.length,
    slidesToScroll: data?.length > 4 ? 4 - 1 : data?.length - 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  useEffect(() => {
    let categories = workshopJourneyCategoryData.filter(
      (category) => !category.IsDisabled
    );
    setData(categories);
  }, [workshopJourneyCategoryData]);

  return (
    <div className={"location-details"}>
      <a className="logo-close" onClick={() => setHide(false)}>
        <FaTimes />
      </a>
      <div>
        <img
          src={`${workShop.CoverImageUrl}`}
          width={"100%"}
          className="p-2"
          alt="workShop.CoverImage"
          style={{
            height: "250px",
            objectFit: "cover",
          }}
        />
      </div>
      <div className="workshop-bar">
        <div className="workshop-list p-2">
          <div className="image-area">
            <img
              src={workShop.LogoUrl}
              width={100}
              className="workshop-img"
              alt="workshop-logo"
            />
          </div>

          <div className="w-100 ml-2">
            <div className="workshop-main-head">
              <div className="workshop-header">{workShop.Name}</div>
            </div>
            <p
              className="m-0 d-flex align-items-center"
              style={{ color: "#6D6D6D", fontSize: 12 }}
            >
              {` ${parseFloat(workShop.Distance).toFixed(2)} KM away`}

              <span className="d-flex align-items-center">
                <WorkshopStars rating={workShop.GoogleRating} />(
                {workShop.GoogleRating})
              </span>
            </p>
            <div className="workshop-distance w-100" style={{ fontSize: 14 }}>
              {`${workShop.AreaName}, `}
              {globalData.locationData.data.Emirate == workShop.EmirateName ? (
                <span className="badge bg-success text-white">
                  {workShop.EmirateName}
                </span>
              ) : (
                <span className="badge bg-yellow text-white">
                  {workShop.EmirateName}
                </span>
              )}
            </div>
            <div style={{ fontSize: "11px" }}>
              <WorkshopTime data={workShop} />
            </div>
          </div>
        </div>
        <Container>
          <Row>
            <Col className="px-1">
              <Scrollbars className="amenties-group w-100">
                {/* <div > */}
                {amenitiesData != null &&
                  amenitiesData.map((e, index) => (
                    <span className="amenties-label mt-1 mr-1">
                      <img
                        src={e.ImgUrl}
                        className="p-1"
                        width={22}
                        alt="ImgUrl"
                      />
                      {e.Name}
                    </span>
                  ))}
                {/* </div> */}
              </Scrollbars>
            </Col>
          </Row>
        </Container>

        <div className="workshop-bottom px-2">
          <div className="workshop-row w-100">
            <span
              className="d-flex align-items-center justify-content-between w-100 mx-2"
              style={{ fontSize: "10px" }}
            >
              <div className="d-flex align-items-center">
                <img
                  src="/assets/images/hand.webp"
                  width={30}
                  alt="hand"
                  style={{ marginRight: 5 }}
                />
                {workShop.LabourWarrantyDays} Days Labour Warranty
              </div>

              <div className="d-flex">
                {workShop.IsObChoice != null && workShop.IsObChoice && (
                  // <div className="workshop-tag-sponsored">SPONSORED</div>
                  <div className="workshop-tag-choice position-relative">
                    <img
                      src="/assets/workshop/choice.svg"
                      width={15}
                      // className="mr-1"
                      title="OB CHOICE"
                      alt="OB CHOICE"
                    />
                    OB CHOICE
                  </div>
                )}
                {/* : workShop.IsObAssured != null && workShop.IsObAssured ? (
                  <div className="workshop-tag-assure position-relative">
                    <img
                      src="/assets/workshop/assure.svg"
                      width={15}
                      // className="mr-1"
                      title="OB ASSURE"
                    />
                    OB ASSURE
                  </div>
                ) : (
                  <div className="workshop-tag-choice position-relative">
                    <img
                      src="/assets/workshop/choice.svg"
                      width={15}
                      // className="mr-1"
                      title="OB CHOICE"
                    />
                    OB CHOICE
                  </div>
                )} */}
                <div className="workshop-tag-assure position-relative ml-2">
                  <img
                    src="/assets/workshop/assure.svg"
                    width={15}
                    // className="mr-1"
                    title="OB ASSURE"
                    alt="OB ASSURE"
                  />
                  OB ASSURE
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
      {workshopJourneyCategoryData != "" ? (
        <Container fluid>
          <h6 className="mb-1 mt-2">Services at this workshop:</h6>
          <Col xs={12} className="service-container">
            <Slider {...settings}>
              {data != "" &&
                data.map((single, index) => {
                  return (
                    <div className="item" key={index}>
                      <div className="categories-box">
                        <Link
                          href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                            "dubai"
                            }/${single.Slug}/null/${workShop.Slug}`}
                        >
                          <a onClick={() => setLoader(true)}>
                            <div
                              className="service-buttons"
                              style={{
                                textDecoration: "none",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "10px",

                                marginLeft: 6,
                                marginRight: 6,
                              }}
                            >
                              <div
                                style={{
                                  // height: "40px",
                                  // width: "60px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  className="service-image"
                                  src={single.ImgUrl}
                                  // width="80%"
                                  height="40px"
                                  alt="service-Img"
                                />
                              </div>
                              <span
                                style={{
                                  fontSize: 12,
                                  fontWeight: "400",
                                  textAlign: "center",
                                  padding: "7px",
                                }}
                              >
                                {single.Name}
                              </span>
                            </div>
                          </a>
                        </Link>
                      </div>
                    </div>
                  );
                })}
            </Slider>
          </Col>
        </Container>
      ) : (
        //   <Services categorySliderData={workshopJourneyCategoryData} inModal />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <div>
            <Skeleton
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
              }}
            />
          </div>
          {[1, 2, 3, 4].map((e) => (
            <div>
              <Skeleton style={{ width: "70px", height: "70px" }} />
              <Skeleton style={{ width: "70px" }} />
            </div>
          ))}
          <div>
            <Skeleton
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
              }}
            />
          </div>
        </div>
      )}
      <h6 className="mb-0 text-center">Interested in this workshop?</h6>
      <div className="d-flex justify-content-center py-2">
        <Link
          onClick={() => {
            sessionStorage.setItem("isWorkshopCollection", "true");
            setCartWorkshop(workShop);
            let mId = globalData.carData?.modelId;
            getWorkshopsJourneyVariant(workShop.Id, id, mId);
            setCartStage(3);
            setIsSubmitting(false);
          }}
          href={`/services/${globalData?.locationData?.data?.EmirateAreaSlug || "dubai"
            }/${data[0]?.Slug}/null/${workShop?.Slug}`}
        >
          <a className="mr-2">
            <button className="btn bg-yellow rounded-pill btn-sm">
              Create Job
            </button>
          </a>
        </Link>
        <Link href={`/workshop/${workShop?.Slug}`}>
          <a className="mr-2">
            <button className="btn btn-primary rounded-pill btn-sm">
              Visit Store
            </button>
          </a>
        </Link>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    globalData: state.globalData,
    apiData: state.apiData,
    loginData: state.loginData,
    profile: state.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearLoginData: () => {
      dispatch(clearLoginData());
    },
    getBrand: () => {
      dispatch(getBrand());
    },
    getModel: (id) => {
      dispatch(getModel(id));
    },
    getCarBrandModal: (
      brand,
      modal,
      logoBrand,
      logoModal,
      brandId,
      modelId
    ) => {
      dispatch(
        getCarBrandModal(brand, modal, logoBrand, logoModal, brandId, modelId)
      );
    },
    fetchCars: () => {
      dispatch(fetchCars());
    },
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkshopModal);
